/* eslint-disable import/no-extraneous-dependencies */
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

import React, {
  useContext,
  useState,
  createContext,
  PropsWithChildren
} from 'react';

import useSWR from 'swr';
import LineService from '../services/LineService';
import { useInternalSession } from './SessionProvider';
import { LoginProvider } from '../constants/auth';

const LineServiceContext = createContext<LineService | undefined>(undefined);

export const LineProvider = ({ children }: PropsWithChildren<unknown>) => {
  const { data } = useInternalSession() as unknown as {
    data: { idToken: string; loginProvider: LoginProvider };
  };
  const [lineService] = useState(
    () => new LineService(data.idToken, data.loginProvider)
  );

  return (
    <LineServiceContext.Provider value={lineService}>
      {children}
    </LineServiceContext.Provider>
  );
};

export function useLineService() {
  const context = useContext(LineServiceContext);

  if (context === undefined) {
    throw new Error('useLineService must be used within a LineServiceContext');
  }
  return {
    lineClient: context,
    useLineInquiryList: () =>
      useSWR('/api/lineInquiries', () => context.listInquiries()),
    useLineMessages: (matchId: string) =>
      useSWR(`/api/lineMessages/${matchId}`, () =>
        context.listMessages(matchId)
      )
  };
}

export default LineProvider;
